import { render, staticRenderFns } from "./linedetails.vue?vue&type=template&id=01956c7f&scoped=true"
import script from "./linedetails.vue?vue&type=script&lang=js"
export * from "./linedetails.vue?vue&type=script&lang=js"
import style0 from "./linedetails.vue?vue&type=style&index=0&id=01956c7f&prod&lang=css"
import style1 from "./linedetails.vue?vue&type=style&index=1&id=01956c7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01956c7f",
  null
  
)

export default component.exports